<template>
	<div class="container">
    <div v-if="this.language == 'de'">
        <p>
        Die Firma schuett-biotec ist Teil einer langen Tradition aus Familienunternehmen. 
        <br>
        <br> Im Jahre XXXX wurde von Herrn Ernst Schuett eine Privategesellschaft, die "Ernst Schuett kaufmännische Gesellschaft" gegründet. 
        Mit der Unterstützung seiner treuen Ehefrau Ulla Schuett und guten Verbindungen in die akademische Landschaft Göttingens wurde er schnell für seine schnellen Beschaffungen 
        und kluges Verkaufsgeschick berühmt.<br>
        <br>
        Der erste wirkliche Durchbruch gelang mit der Konstruktion des ersten elektrischen Gasbunsenbrenner mit dem wohlklingenden Namen "flammy".<br>
        <br>
        <ul>
          <li> schuett-Labortechnik Gmbh </li>
          <li> schuett24 </li>
          <li> schuett-biotec </li>
          <li> Generationswechsel </li>
         </ul>

        
        </p>
          


    </div>
    <div v-if="this.language == 'en'">
      <p>
      ...::: Site under Construction:::...

          </p>
        


    </div>
	</div>
</template>
<script>
export default {
    name: 'historie',
    data () {
      return {}
    }
};
</script>
<style scoped>
	.container {
    color: black;
    margin: 1rem;
    white-space: pre-line;
  }
  
  table {
    width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/historie.vue